export default "/images/6234d26577821e73c51af22580c06510.avif";